import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.mixins;

export default class Mixins extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      trial_id: this.number(null),
      unique_id: this.string(''),
      name: this.string(''),
      code: this.string(''),
      ingredients: this.attr([]),
      white_masses: this.attr([]),
      premixes: this.attr([]),
      custom_ingredients: this.attr([]),
      packages: this.attr([]),
      product_needed: this.number(100),
      workdate: this.attr(''),
      status: this.attr('HOLD'),
      status_notes: this.attr(''),
      trial: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/modules/mixing',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/',
          method: 'get',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/:id/by_list/',
          method: 'patch',
        },
      },
    },
  };
}
